// extracted by mini-css-extract-plugin
export var container = "_fs-1";
export var cornerButtonContainer = "_fs-6";
export var disabled = "_fs-2";
export var dragActive = "_fs-3";
export var fileContainer = "_fs-5";
export var hiddenInput = "_fs-4";
export var widthContainer = "_fs-0";